import {
  GET_PROJECT_PACKAGES,
  GET_PROJECT_PACKAGES_SUCCESS,
  GET_PROJECT_PACKAGES_FAIL,
  GET_ALL_PROJECT_PACKAGES,
  GET_ALL_PROJECT_PACKAGES_SUCCESS,
  GET_ALL_PROJECT_PACKAGES_FAIL,
  UPDATE_PROJECT_PACKAGE_INSTALLER,
  UPDATE_PROJECT_PACKAGE_INSTALLER_SUCCESS,
  UPDATE_PROJECT_PACKAGE_INSTALLER_FAIL,
  UPDATE_PROJECT_PACKAGE_SERIAL,
  UPDATE_PROJECT_PACKAGE_SERIAL_SUCCESS,
  UPDATE_PROJECT_PACKAGE_SERIAL_FAIL,
  RESET_PROJECT_PACKAGES_FLAG,
} from "./actionTypes"

// Get Project Packages
export const getProjectPackages = gasProjectId => ({
  type: GET_PROJECT_PACKAGES,
  payload: gasProjectId,
})

export const getProjectPackagesSuccess = data => ({
  type: GET_PROJECT_PACKAGES_SUCCESS,
  payload: data,
})

export const getProjectPackagesFail = error => ({
  type: GET_PROJECT_PACKAGES_FAIL,
  payload: error,
})

// Get All Project Packages (for Installer)
export const getAllProjectPackages = (gasProjectId = null) => ({
  type: GET_ALL_PROJECT_PACKAGES,
  payload: gasProjectId,
})

export const getAllProjectPackagesSuccess = data => ({
  type: GET_ALL_PROJECT_PACKAGES_SUCCESS,
  payload: data,
})

export const getAllProjectPackagesFail = error => ({
  type: GET_ALL_PROJECT_PACKAGES_FAIL,
  payload: error,
})

// Update Project Package Installer
export const updateProjectPackageInstaller = data => ({
  type: UPDATE_PROJECT_PACKAGE_INSTALLER,
  payload: data,
})

export const updateProjectPackageInstallerSuccess = data => ({
  type: UPDATE_PROJECT_PACKAGE_INSTALLER_SUCCESS,
  payload: data,
})

export const updateProjectPackageInstallerFail = error => ({
  type: UPDATE_PROJECT_PACKAGE_INSTALLER_FAIL,
  payload: error,
})

// Update Project Package Serial (for Installer)
export const updateProjectPackageSerial = data => ({
  type: UPDATE_PROJECT_PACKAGE_SERIAL,
  payload: data,
})

export const updateProjectPackageSerialSuccess = data => ({
  type: UPDATE_PROJECT_PACKAGE_SERIAL_SUCCESS,
  payload: data,
})

export const updateProjectPackageSerialFail = error => ({
  type: UPDATE_PROJECT_PACKAGE_SERIAL_FAIL,
  payload: error,
})

// Reset Flags
export const resetProjectPackagesFlag = () => ({
  type: RESET_PROJECT_PACKAGES_FLAG,
})

